import { Brain, Send, Settings, Upload, Wallet } from "lucide-react";
import { Template } from "./types";
import { CampaignData } from "../../../components/types";
import { SingleCampaignResponse } from "../campaign/types";

export const steps = [
  {
    id: 1,
    title: "Brief",
    icon: Settings,
    description: "Basic campaign configuration",
  },
  {
    id: 2,
    title: "Details",
    icon: Upload,
    description: "CSV file upload and validation",
  },

  {
    id: 3,
    title: "Messaging",
    icon: Brain,
    description: "Generate personalized messages",
  },

  {
    id: 4,
    title: "Preview and Launch",
    icon: Send,
    description: "Final review and deployment",
  },
];

// Instagram has its own path: ad set details sit under Details, and budget and
// schedule get a page of their own before review.
export const instagramSteps = [
  { id: 1, title: "Brief", icon: Settings, description: "Basic campaign configuration" },
  { id: 2, title: "Details", icon: Upload, description: "Broadcast and ad set details" },
  { id: 3, title: "Messaging", icon: Brain, description: "Ad creative and copy" },
  { id: 4, title: "Budget and Schedule", icon: Wallet, description: "Budget and start time" },
  { id: 5, title: "Review and Launch", icon: Send, description: "Final review and deployment" },
];

// ─────────────────────────────────────────────────────────────
// Props Interface
// ─────────────────────────────────────────────────────────────

export interface MessagingProps {
  campaignData: CampaignData
  setCampaignData: React.Dispatch<React.SetStateAction<CampaignData>>;
  onValidation?: (isValid: boolean) => void;
  onSubmit?: (data: Partial<CampaignData>) => void;
  onBack: () => void;
  singleCampaign?: SingleCampaignResponse | null; // Add this
}

// ─────────────────────────────────────────────────────────────
// Constants & Helper Functions
// ─────────────────────────────────────────────────────────────

export const CUSTOMER_NAME_OPTIONS = ["First_Name", "Last_Name", "Full_Name", "Nickname"];

export function typeBadgeClass(type: Template["type"]) {
  return type === "Text"
    ? "bg-indigo-50 text-indigo-600 border border-indigo-200"
    : "bg-violet-50 text-violet-600 border border-violet-200";
}

export const VARIABLE_COLORS = [
  "bg-indigo-200 text-[#6366F1]"
];
